function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LOW_BALANCE_INTERVAL = 12 * 60 * 60 * 1000;
var lastLowBalanceEmail = 0;
function decimals(app, value) {
  var _app$browser;
  if (typeof (app === null || app === void 0 || (_app$browser = app.browser) === null || _app$browser === void 0 ? void 0 : _app$browser.formatDecimals) === 'function') {
    return app.browser.formatDecimals(value, true);
  }
  return String(value !== null && value !== void 0 ? value : '');
}
function send(app, message) {
  var _app$connection, _app$connection$emit;
  (_app$connection = app.connection) === null || _app$connection === void 0 || (_app$connection$emit = _app$connection.emit) === null || _app$connection$emit === void 0 || _app$connection$emit.call(_app$connection, 'mailrelay-send-email', _objectSpread({
    to: 'migration@saito.tech',
    from: 'Saito Token Migration <info@saito.tech>',
    ishtml: true,
    bcc: 'migration@saito.io'
  }, message));
}
function sendLowBalanceEmail(app, balance) {
  var now = Date.now();
  if (lastLowBalanceEmail && now - lastLowBalanceEmail < LOW_BALANCE_INTERVAL) {
    return;
  }
  lastLowBalanceEmail = now;
  send(app, {
    subject: "Low Balance Warning: ".concat(decimals(app, balance)),
    text: 'Please deposit more SAITO ASAP',
    ishtml: false
  });
}
function sendStatusEmail(app, result, payment) {
  var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var amount = (payment === null || payment === void 0 ? void 0 : payment.outbound_amount) || (payment === null || payment === void 0 ? void 0 : payment.inbound_amount) || '';
  var ticker = (payment === null || payment === void 0 ? void 0 : payment.inbound_ticker) || '';
  var recipient = (payment === null || payment === void 0 ? void 0 : payment.recipient_publickey) || '';
  var subject = 'Saito Token Automated Migration Alert';
  var html = '';
  if (result === 2) {
    subject += ' (Complete!)';
    html = "<div><p>Saito Automated Migration Complete!</p><hr><p>Migration issued ".concat(decimals(app, amount), " ").concat(ticker, " to ").concat(recipient, "</p><p>").concat(detail || '', "</p></div>");
  } else if (result === 1) {
    subject += ' (Submitted)';
    html = "<div><p>Saito Automated Migration Transfer Service</p><hr><p>TICKER: ".concat(ticker, "</p><p>AMOUNT: ").concat(decimals(app, amount), "</p><p>FROM: ").concat((payment === null || payment === void 0 ? void 0 : payment.inbound_sender) || '', "</p><p>PUBLICKEY: ").concat(recipient, "</p><p>EMAIL: ").concat((payment === null || payment === void 0 ? void 0 : payment.email) || '', "</p><p>Signed SAITO payout submitted; awaiting on-chain confirmation.</p></div>");
  } else {
    subject += ' (Error)';
    html = "<div><p>Saito Automated Migration Transfer Service</p><hr><p>TICKER: ".concat(ticker, "</p><p>AMOUNT: ").concat(decimals(app, amount), "</p><p>PUBLICKEY: ").concat(recipient, "</p><p>EMAIL: ").concat((payment === null || payment === void 0 ? void 0 : payment.email) || '', "</p><p>Error: ").concat(detail || '', "</p></div>");
  }
  send(app, {
    subject: subject,
    html: html
  });
}
function sendFailureNotice(app, publicKey) {
  var _app$network;
  var mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!publicKey) {
    return;
  }
  if (mod && typeof mod.notifyBrowser === 'function') {
    mod.notifyBrowser('migration failure', {
      data: null
    }, publicKey);
    return;
  }
  if (!(app !== null && app !== void 0 && (_app$network = app.network) !== null && _app$network !== void 0 && _app$network.sendRequestAsTransaction)) {
    return;
  }
  app.network.sendRequestAsTransaction('migration failure', {
    data: null
  }, null, publicKey);
}
module.exports = {
  sendLowBalanceEmail: sendLowBalanceEmail,
  sendStatusEmail: sendStatusEmail,
  sendFailureNotice: sendFailureNotice
};